import styled from "styled-components";

const StyledAboutPage = styled.section`
  width: 100vw;
  background-color: #1c112b;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  position: relative;
  padding-bottom: 50px;
`;

export { StyledAboutPage };
